import { JwtHelperService } from '@auth0/angular-jwt';
import { LocalStorageKeys } from '../constants/local-storage';

const helper = new JwtHelperService();
const token = localStorage.getItem(LocalStorageKeys.ID_TOKEN);
let role = '';

if (token) {
  const decodedToken = helper.decodeToken(token);
  role = decodedToken.role;
}

export function hasReportsOnlyAccess(): boolean {
  return role === 'reportsonly';
}
